import './contenuto-rte.scss';
import Tooltip from 'bootstrap-italia/src/js/plugins/tooltip';

/**
 * version    1.0
 * class      ContenutoRte
 */
export class ContenutoRte {
  constructor() {
    this.breakpoint = 768;
    this.init();
  }

  init() {
    this.handleEmailCopy();
  }

  /**
   * Copia email + tooltip
   */
  handleEmailCopy() {
    const emails = document.querySelectorAll('.js-email-copy');

    emails.forEach((el) => {
      const { email } = el.dataset;
      const element = el;

      const isMobile = window.innerWidth < this.breakpoint;

      const tooltip = new Tooltip(element, {
        trigger: 'manual',
        offset: isMobile ? [0, 0] : [0, 0],
        placement: 'top',
        title: 'Email copiata!',
      });

      element.style.cursor = 'pointer';

      element.addEventListener('click', async () => {
        await navigator.clipboard.writeText(email);

        tooltip.show();

        setTimeout(() => {
          tooltip.hide();
        }, 1500);
      });
    });
  }
}
